/**
 * Skip to main content link for keyboard navigation accessibility (WCAG 2.4.1)
 * This link is visually hidden but becomes visible when focused
 */
export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-white focus:text-gray-900 focus:rounded-lg focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:font-medium"
    >
      Skip to main content
    </a>
  )
}
